module.exports = __webpack_public_path__ + "static/media/buscarPro.3b844ed2.svg";